import PropTypes from 'prop-types';
import { Typography, Icon, Button } from '@bwoty-web/ui-kit';
import { UI_USER_CIRCLE } from '@bwoty-web/ui-kit/icons';
import './LogoutPanel.scss';
import cx from 'classnames';
import { useGlobals } from '@bwoty-web/ui-kit/hooks';
import logout from '../logout';
import { getDomainInBrowser } from '../../../../../server/utils/requestInfo';

const checkActive = (id, logoutPanelLinkId) => {
  return parseInt(id, 10) === parseInt(logoutPanelLinkId, 10);
};

const LogoutPanel = ({ logoutPanelCollection, membershipGivenName }) => {
  const { logoutPanelLinkId = 0, subDomain  } = useGlobals(); 
  
  const handleLogout = () => {  
    logout(`https://${subDomain}.${getDomainInBrowser()}/api/logout`);
  };

  return (
    <div className="headerfooter-logout__container">
      <div className="headerfooter-logout-panel__background" />
      <div className="headerfooter-logout-panel">
        <div className="headerfooter-logout-panel__content">
          <div>
            <span className="headerfooter-logout-panel__portrait-icon">
              <Icon path={UI_USER_CIRCLE} aria-hidden="true" size="m" sizeMobile="m" />
            </span>
          </div>
          <div>
            <div>
              <Typography as="h1" variant="headline-s">
                {membershipGivenName}
              </Typography>
            </div>
          </div>
        </div>
        <div className="container">
          {logoutPanelCollection?.linkArray?.map((link) => {
            const { id, url } = link.href;

            if (!url) return null;
            return (
              <a
                key={id}
                href={url}
                className={cx(
                  'headerfooter-logout-header-link',
                  checkActive(id, logoutPanelLinkId) ? 'active' : '',
                )}
              >
                <Typography as="h2" variant="mini">
                  {link?.title}
                </Typography>
              </a>
            );
          })}

          <Button
            id="logout-button"
            onClick={handleLogout}
            className="headerfooter-logout-header-logout-button"
            variant="ghost"
          >
            <Typography
              as="h2"
              className="headerfooter-logout-button-text"
              variant="mini"
            >
              {logoutPanelCollection?.logoutText}
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  );
};

LogoutPanel.defaultProps = {
  logoutPanelCollection: {
    linkArray: [],
  },
  membershipGivenName: '',
};
LogoutPanel.propTypes = {
  membershipGivenName: PropTypes.string,
  logoutPanelCollection: PropTypes.shape({
    linkArray: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        href: PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
          target: PropTypes.string,
        }),
      }),
    ),
    logoutText: PropTypes.string,
  }),
};

export default LogoutPanel;
